"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  listBox: {
    backgroundColor: '#fff',
    boxShadow: '0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)',
    width: 654,
    margin: 0,
    padding: 0,
    zIndex: 1,
    position: 'absolute',
    listStyle: 'none',
    overflow: 'auto',
    maxHeight: 488,
    [_theme.default.breakpoints.down('xs')]: {
      width: 'auto',
      left: 25,
      right: 25
    },
    '& ul': {
      paddingLeft: 0,
      margin: 0
    },
    '& li': {
      color: _theme.default.palette.grayScale.dark,
      fontFamily: _theme.default.typography.proxima.regular,
      display: 'flex',
      alignItems: 'center',
      fontSize: 16,
      padding: 0,
      '& svg': {
        width: 24,
        height: 24,
        color: _theme.default.palette.grayScale.main,
        marginRight: 8
      }
    },
    '& li[data-focus="true"]': {
      backgroundColor: _theme.default.palette.grayScale.light,
      cursor: 'pointer'
    },
    '& li:active': {
      backgroundColor: _theme.default.palette.grayScale.light
    }
  }
});
var _default = exports.default = useStyles;